import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  pricingInput: {
    width: '457px !important',
  },
  pricingInputsContainer: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  marginBottom: {
    marginBottom: '16px',
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  currency: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#6A777A',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },

  textClass: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    color: '#2E3132',
  },
}))
